import { FC, useEffect, useRef } from 'react'
import { TileLayer, ZoomControl } from 'react-leaflet'

import { Map } from 'leaflet'
import { useRoutePlanning } from 'providers/RoutePlanningProvider'
import { MapWrapper } from './element'

type MapProps = {
  longitude: number
  latitude: number
  width?: string
  height: string
  zoom: number
}

const LeafletMap: FC<MapProps> = ({
  longitude,
  latitude,
  width,
  zoom,
  height,
  children,
}) => {
  const map = useRef<Map | null>(null)
  const { markerHovered, getMarkers, selectedOrders } = useRoutePlanning()

  useEffect(() => {
    if (markerHovered || selectedOrders?.length > 0) {
      const markers = getMarkers()
      const positions = Object.keys(markers)
      positions.forEach((position) => {
        if (map.current) {
          const pane = map.current.getPane(`routemarker${position}`)
          const selected = selectedOrders
            .map((order) => order.latlng)
            .includes(position)
          if (pane) {
            if (markerHovered?.latlng === position) {
              pane.style.zIndex = '3000'
            } else if (selected) {
              pane.style.zIndex = '2000'
            } else {
              pane.style.zIndex = '1000'
            }
          }
        }
      })
    }
  }, [markerHovered])

  return (
    <div id='map'>
      <MapWrapper
        ref={map}
        key={height}
        height={height}
        center={[latitude, longitude]}
        zoom={zoom}
        width={width || 'auto'}
        scrollWheelZoom
        zoomControl={false}>
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
        {children}
        <ZoomControl position='bottomright' />
      </MapWrapper>
    </div>
  )
}
export default LeafletMap
